import React from 'react';

import { useSafeImageSrc } from './SafeImage';

const RoundImage = (props) => {
    const { src, altSrc, className = '', style, size, children, onClick } = props,
        checkedSrc = useSafeImageSrc(src, altSrc);

    if (!checkedSrc) return null;

    return (
        <div
            className={['img', className].join(' ')}
            onClick={onClick}
            style={{
                ...style,
                backgroundImage: `url('${checkedSrc}')`,
                width: size,
                height: size,
                borderRadius: '50%',
            }}>
            {children}
        </div>
    );
};

export default RoundImage;
